<template>
  <div v-show="showModal" ref="captionModal">
    <hi-dialog class="caption-dialog" :title="modalTitle" @close="closeDialog">
      <hi-button
        class="edit-btn"
        :disabled="editDisabled"
        type="text"
        slot="left"
        v-show="!edit && tabIndex !== 2"
        @click.native="editClick"
        >Edit
      </hi-button>
      <hi-button
        class="edit-btn"
        type="text"
        slot="left"
        v-show="edit && tabIndex !== 2"
        @click.native="cancelClick"
      >
        Cancel
      </hi-button>
      <div class="main-container">
        <hi-tab :tabList="tabList" v-model="tabIndex" class="tab"></hi-tab>
        <div v-show="tabIndex === 0" class="history-page">
          <calender-caption
            :edit="edit"
            :key="history.id"
            @click="captionItemClick"
            :model="history"
            v-for="history in captionHistories"
          ></calender-caption>
          <div v-if="captionHistories.length === 0" class="no-list">
            {{ noCaptionText }}
          </div>
        </div>
        <div v-show="tabIndex === 1" class="tag-page">
          <div class="tags-container">
            <calender-caption
              :edit="edit"
              :key="tag.id"
              @click="captionItemClick"
              :model="tag"
              v-for="tag in captionTags"
            ></calender-caption>
            <div v-if="captionTags.length === 0" class="no-list">
              {{ noSavedText }}
            </div>
          </div>
          <div v-show="!edit" class="bottom-container">
            <div class="save-text-container">
              <form-text-area-component
                placeholder="Add Hashtags & Caption"
                v-model="addTagText"
              >
              </form-text-area-component>
            </div>
            <button class="save-btn" @click="saveTag">Save</button>
          </div>
        </div>
        <suggested
          v-show="tabIndex === 2"
          @itemClick="captionItemClick"
        ></suggested>
        <div v-show="edit" class="del-bottom-container">
          <hi-button class="btn" type="text" @click.native="allClick"
            >Select All</hi-button
          >
          <hi-button
            class="btn"
            type="text"
            :disabled="delDisabled"
            @click.native="delClick"
            >Delete</hi-button
          >
        </div>
      </div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.caption-dialog {
  width: 375px;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  height: 730px;

  .no-list {
    display: flex;
    font-size: 16px;
    color: gray;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .edit-btn {
    padding: 0;
  }

  .tab {
    padding: 0 20px;
    border-bottom: 1px solid #e6e6e6;
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .tab-container {
      margin: 0 20px;
    }

    .tag-page {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;

      .tags-container {
        flex: 1;
        overflow: auto;
      }

      .bottom-container {
        text-align: center;
        background: white;
        border-top: 1px solid #d2d2d2;
        padding: 15px;

        .save-text-container {
          font-size: 14px;
          border-radius: 3px;
          border: 1px solid #d2d2d2;
          background: #f5f5f5;
          width: 100%;
          box-sizing: border-box;
          padding: 12px 12px 3px 12px;
        }

        .save-btn {
          color: @color-primary;
          font-size: 14px;
          border: 1px solid #e5e5e5;
          border-radius: 3px;
          height: 40px;
          padding: 0 14px;
          width: 100%;
          cursor: pointer;
          -webkit-appearance: button;
          background: white;
          margin-top: 10px;
        }
      }
    }

    .del-bottom-container {
      border-top: 1px solid #d2d2d2;
      padding: 0 20px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn {
        font-size: 16px;
        padding: 0;
      }
    }

    .history-page {
      overflow: auto;
      flex: 1;
    }
  }
}
</style>
<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiTab from "../../../common/tab/Tab";
import calenderCaption from "../../../calender/caption/Index.vue";
import hiButton from "../../../common/button/Index";
import suggested from "../../../media/schedule/suggested/Suggested";
import FormTextAreaComponent from "../../../common/form/TextArea";
import store from "../../../../store/index";
import {
  createUserContent,
  delUserContent,
  getUserContent,
} from "../../../../service/publisher";
import { showErrorMsg } from "../../../../utils/errors";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";

export default {
  name: "CalenderScheduleCaptionComponent",
  components: {
    FormTextAreaComponent,
    hiDialog,
    calenderCaption,
    hiTab,
    hiButton,
    suggested,
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    socialNetwork: {
      type: String,
      default: "",
    },
    form: {
      //  表单
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      // add 只是单独用于添加comment所需
      type: String,
      default: "form",
    },
    publisherId: {
      default: () => {
        // 如果设置了publisherId则读取设置 否则默认是当前
        return store.getters[CURRENT_PUBLISHER_SIMPLE].publisherId;
      },
    },
  },
  computed: {
    noCaptionText() {
      if (this.socialNetwork === "twitter") {
        return "No history here";
      }
      return "No history here";
    },
    noSavedText() {
      if (this.socialNetwork === "twitter") {
        return "No history here";
      }
      return "No history here";
    },
    /**
     * 弹出层标题
     */
    modalTitle() {
      if (this.socialNetwork === "twitter") {
        return "Tweets";
      }
      return "Caption";
    },
    /**
     * 数量不足不可编辑
     */
    editDisabled() {
      return this.captionHistories.length + this.captionTags.length === 0;
    },
    /**
     * 如果一项都未选中则无法删除
     */
    delDisabled() {
      // 当前选项是否至少存在一项
      if (this.tabIndex === 0) {
        const select = this.captionHistories.find((c) => c.select);
        return select === undefined;
      } else {
        const select = this.captionTags.find((c) => c.select);
        return select === undefined;
      }
    },
    tabList() {
      let list = [{ title: "History" }, { title: "Saved" }];
      if (this.socialNetwork === "instagram") {
        list.push({ title: "Suggested #" });
      }
      return list;
    },
  },
  data() {
    return {
      edit: false, // 是否开启编辑模式
      showModal: this.show,
      addTagText: "",
      tabIndex: 0,
      captionHistories: [],
      captionTags: [],
    };
  },
  methods: {
    /**
     * 选中所有点击事件
     */
    allClick() {
      // 选中history
      if (this.tabIndex === 0) {
        this.captionHistories.forEach((c) => {
          c.select = true;
        });
      } else {
        this.captionTags.forEach((c) => {
          c.select = true;
        });
      }
    },
    /**
     * 删除选中项点击事件
     */
    async delClick() {
      let delIds = [];
      // 选中history
      if (this.tabIndex === 0) {
        delIds = this.captionHistories
          .filter((c) => c.select === true)
          .map((d) => d.id);
      } else {
        delIds = this.captionTags
          .filter((c) => c.select === true)
          .map((d) => d.id);
      }
      if (delIds.length > 0) {
        const loading = this.$loading({ target: this.$refs.captionModal });
        try {
          await delUserContent({ publisherId: this.publisherId, ids: delIds });
          // 取消编辑模式
          this.edit = false;
          // 更新caption数据
          this.updateCaptionList();
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
    },
    /**
     * 编辑按钮点击事件
     */
    editClick() {
      this.edit = true;
    },
    /**
     * 取消按钮点击事件
     */
    cancelClick() {
      this.edit = false;
    },
    /**
     * 关闭dialog点击事件
     */
    async closeDialog() {
      this.showModal = false;
    },
    // tag被点击回调 直接選中tag文字添加到form中
    captionItemClick(item) {
      if (this.edit) {
        // 如果处于编辑状态,则点击则进行勾选
        item.select = !item.select;
      } else {
        this.$parent.$refs.caption.addText(item.text);
      }
      this.$nextTick(() => {
        this.$parent.validateUrl();
      });
    },
    // 添加tag
    async saveTag() {
      if (this.addTagText) {
        const loading = this.$loading({ target: this.$refs.captionModal });
        try {
          const form = {
            content_type: 1,
            content: this.addTagText,
            is_saved: true,
            is_history: false,
          };
          await createUserContent({ publisherId: this.publisherId, form });
          this.edit = false;
          this.updateCaptionList();
          this.addTagText = "";
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
    },
    /**
     * 更新caption信息
     */
    async updateCaptionList() {
      // 获取当前指定publisher的comment
      const list = await getUserContent({
        type: "caption",
        publisherId: this.publisherId,
      });
      list.forEach((l) => {
        l.text = l.content;
        l.date = l.date_created;
        l.select = false;
      });
      this.captionHistories = list.filter((comment) => comment.is_history);
      this.captionTags = list.filter((comment) => comment.is_saved);
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.tabIndex = 0;
        this.addTagText = "";
      }
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
    async publisherId(val) {
      // 获取当前指定publisher的comment
      await this.updateCaptionList();
    },
  },
  async created() {
    const loading = this.$loading({ target: this.$refs.captionModal });
    try {
      // 获取当前指定publisher的comment
      await this.updateCaptionList();
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
